export default "__VITE_ASSET__C1h4akb7__"